import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "4",
  fill: "none",
  viewBox: "0 0 30 4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M28 0a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z"
    }, null, -1)
  ]))]))
}
export default { render: render }